module.exports = __webpack_public_path__ + "img/icon_setting_blue.f800b63c.svg";